import common from ".";
import global from "../../config/global";

const aliasStatus = (alias) => {
  if (!alias.block_spam && alias.enabled) {
    return 'forward'
  }
  if (alias.block_spam && alias.enabled) {
    return 'block_spam'
  }
  return 'block_all_emails'
}

const clickBuyPremium = () => {
  global.navigate(global.keys.MANAGE_PLANS)
}

const clickSettingPlansBilling = () => {
  global.navigate(global.keys.SETTINGS_PLANS_BILLING)
}


const allMenus = () => {
  return global.menus.ADMIN_MENUS.filter((m) => {
    let isPlan = true;
    let isUserType = true;
    let isCountry = true;
    const userInfo = global.store.getState().auth?.userInfo;
    if (userInfo) {
      const plan = global.store.getState().payment?.plan;
      if (m.plans && plan) {
        isPlan = m.plans.includes(plan?.alias);
        if (common.isFamilyUser()) {
          isPlan = false;
        }
      }
      if (m.userTypes) {
        isUserType = m.userTypes.includes(userInfo?.pwd_user_type);
      }
      if (m.country) {
        isCountry = userInfo.resourceLang?.country_code === m.country
      }
    }
    return isPlan && isUserType && isCountry
  });
}

const adminRouters = () => {
  return global.routers.ADMIN_ROUTERS.filter((r) => {
    let isPlan = true;
    let isUserType = true;
    let isCountry = true;
    const userInfo = global.store.getState().auth?.userInfo;
    if (userInfo) {
      const plan = global.store.getState().payment?.plan;
      if (r.plans && plan) {
        isPlan = r.plans.includes(plan?.alias);
        if (common.isFamilyUser()) {
          isPlan = false;
        }
      }
      if (r.userTypes) {
        isUserType = r.userTypes.includes(userInfo?.pwd_user_type);
      }
      if (r.country) {
        isCountry = userInfo.resourceLang?.country_code === r.country
      }
    }
    return isPlan && isUserType && isCountry
  });
}

const allRouters = () => {
  return [
    ...global.routers.AUTH_ROUTERS.map(r => ({ ...r, type: 'auth' })),
    ...global.routers.ERROR_ROUTERS.map(r => ({ ...r, type: 'error' })),
    ...global.routers.PUBLIC_ROUTERS.map(r => ({ ...r, type: 'public' })),
    ...adminRouters().map(r => ({ ...r, type: 'admin' })),
  ].map(r => ({
    ...r,
    keys: r.path.split('/'),
  }))
}

const openDesktopApp = () => {
  window.location.replace(`lockerapp://`)
}

const getTrialPlan = () => {
  const trialPlan = common.getTrialPlanStorage();
  if (trialPlan) {
    return trialPlan
  }
  return undefined
}

const getErrorMessage = (error) => {
  const errorData = error?.response?.data || error?.response || error;
  if (errorData?.code &&  global.constants.ERROR_CODES.includes(errorData?.code)) {
    return {
      code: errorData?.code
    }
  }
  let message = errorData?.message || error?.message || error.toString();
  if (errorData?.details && !common.isEmpty(errorData?.details)) {
    const errorKeys = Object.keys(errorData.details)
    message = errorData.details[errorKeys[0]][0] || errorData.details[errorKeys[0]] || message;
  }
  return {
    message: message
  }
}

const displayPlanName = () => {
  const plan = global.store.getState().payment?.plan;
  let planName = ""
  switch (plan?.alias) {
    case global.constants.PLANS.FREE:
      planName = "plans.free";
      break;
    case global.constants.PLANS.PREMIUM:
      planName = "plans.premium";
      break;
    case global.constants.PLANS.FAMILY:
      planName = "plans.family";
      break;
    case global.constants.PLANS.LIFETIME_FAMILY:
      planName = "plans.lifetime_family";
      break;
    case global.constants.PLANS.LIFETIME_TEAM:
      planName = "plans.lifetime_team";
      break;
    case global.constants.PLANS.LIFETIME_PREMIUM:
      planName = "plans.lifetime_premium";
      break;
    default:
      planName = "";
      break;
  }
  return planName;
}

export default {
  aliasStatus,
  clickBuyPremium,
  clickSettingPlansBilling,
  allMenus,
  adminRouters,
  allRouters,
  openDesktopApp,
  getTrialPlan,
  getErrorMessage,
  displayPlanName
}